import { Component, computed } from '@angular/core';
import { AbbChartComponent } from '@components/abb-chart/abb-chart.component';
import { CustomWidget } from '../widget';
import { TPipe, TRANSLATION_PREFIX } from '@pipes/t.pipe';

@Component({
  selector: 'abb-donut-chart-widget',
  standalone: true,
  imports: [AbbChartComponent, TPipe],
  template: `
    <div class="h-full w-full flex flex-col items-center">
      <span class="font-normal">
        {{ dataChart().label?.text | t }}
        @if(dataChart().label?.unit){ ({{ dataChart().label?.unit }}) }
      </span>
      <abb-chart
        class="block"
        [chartType]="'doughnut'"
        [dataChart]="dataChart()"
        [yAxisLabel]="dataChart().label"
        [grow]="true"
        [useCustomLabels]="false"
        [xAxisType]="'category'"
      ></abb-chart>
    </div>
  `,
  styles: ``,
  host: {
    class: 'h-full w-full block',
  },
})
export class DonutChartWidgetComponent extends CustomWidget {
  dataChart = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'ChartData' && data.series && data.series.length > 0) {
      const firstSeries = data.series[0];
      // Ensure first series exists and has values array
      if (!firstSeries || !firstSeries.values || !Array.isArray(firstSeries.values)) {
        return { series: [], labels: [], label: { text: '', unit: '' } };
      }
      
      return {
        labels: firstSeries.values.map((v) => v?.x ?? ''),
        series: data.series.map(({ name, values }) => ({
          name: data.label?.text ?? name,
          values: (values || []).map((v) => v?.y ?? 0),
        })),
        label: data.label, 
      };
    }
    return { series: [], labels: [], label: { text: '', unit: '' } };
  });
}
